// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/Socialico-Regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/Socialico-Regular.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/Socialico-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/SocialicoPlus-Plus.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/SocialicoPlus-Plus.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/SocialicoPlus-Plus.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("/src/img/bk-upptokur-cover.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Schibsted+Grotesk:ital,wght@0,400;0,700;1,400;1,700&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Socialico";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format('embedded-opentype'),
  url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format('woff2'),
  url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format('woff');
}

@font-face {
  font-family: "SocialicoPlus";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('embedded-opentype'),
  url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2'),
  url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format('woff');
}


body {
  background: hsl(240, 20%, 10%);
  color: hsl(42, 100%, 87%);
  margin: 0;
  padding: 0;
  font-family: 'Schibsted Grotesk', sans-serif;
  padding: 1rem 0 4rem;

  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  background-size: 100%;
  background-repeat: no-repeat;
  background-position: 0 150px;
  position: relative;
}

@media (min-width: 768px) {
  body {
    background-position: 0 0px;
  }
}

@media (min-width: 992px) {
  body {
    background-position: 0 -70px;
  }
}


@media (min-width: 1200px) {
  body {
    background-position: 0 -130px;
  }
}

@media (min-width: 1400px) {
  body {
    background-position: 0 -200px;
  }
}

body:before {
  content: '';
  position: absolute;
  inset: 0;
  background: hsla(240, 20%, 10%, .5);
  z-index: -1;
}

hr,
.seperator {
  border: none;
  border-top: 15px solid #ffebbe;
}

.seperator {
  margin: 3rem 0;
}

h1, h2, h3, h4 {
  line-height: 1.2;
}

.logo {
  width: 75%;
  max-width: 500px;
  margin-top: 4rem;
  z-index: 20;
}

.header, .main, .footer {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 0;
}

.header {
  //padding-bottom: 10rem;
}

.header nav {
  padding: 2rem 0;
  font-size: 1.25rem;
}

.desktop-menu {
  padding: 0;
  margin: 0;
  list-style: none;
  display: none;
  grid-gap: 20px;
}

.header nav li a {
  color: #ffebbe;
  text-decoration: none;
}

.header nav li a.active {
  font-weight: 700;
}

.mobile-menu {
  display: none;
  text-align: center;
  padding-top: 300px;
  position: absolute;
  inset: 0;
  color: hsl(42, 100%, 87%);
  background: hsla(240, 20%, 10%,.9);
}

.mobile-menu.open {
  display: block;
}

.mobile-menu ul {
  list-style: none;
  padding: 0;
}

.mobile-menu li {
  margin-bottom: 10px;
}

.desktop-menu {
  display: none;
  list-style: none;
  padding: 0;
}

.desktop-menu li {
  margin-right: 20px;
}

.mobile-menu-toggle,
.close-menu-btn {
  background: none;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  padding: 10px;
  background: hsl(42, 100%, 87%);
  aspect-ratio: 1/1;
  width: 2.5rem;
  height: 2.5rem;
  font-weight: 700;
  line-height: 1.125;
  border-radius: 50%;
}

@media (min-width: 768px) {
  .desktop-menu {
    display: flex;
  }

  .mobile-menu-toggle {
    display: none;
  }
}

.main-content {
  width: 600px;
  max-width: 75%;
  text-shadow: 2px 2px 5px #14141e;
}

.content-album,
.content-youtube,
.content-play {
  margin: 2rem 0 2rem;
  z-index: 10;
}

.content-youtube {
padding: 0 1rem;
}

.content-album iframe {
  width: 100%;
  aspect-ratio: 5 / 6;
}

.content-youtube iframe {
  max-width: 100vw;
  max-height: 56.25vw;
}

.content-play svg {
width: 90px;
height: 90px;
}

.content-text {
  z-index: 20;
  font-size: 1.25rem;
  line-height: 1.5;
}

.content-text.home {
  font-size: 1.5rem;
  text-align: center;
  margin-top: 6rem;
}

@media (min-width: 768px) {
  .content-text.home {
    margin-top: 12rem;
  }
}

.content-album {
  font-size: 1rem;
  line-height: 1.4;
  
}

.track-title {
  padding-top: 1rem;
  margin-top: 5rem;
  border-top: 15px solid #ffebbe;
}


@media (min-width: 900px) {
  .content-youtube,
  .content-play {
      margin-top: 3rem;
  }

  .content-play svg {
    width: 120px;
    height: 120px;
  }

  .content-text {
      margin-top: 6rem;
  }
}

@media (min-width: 1200px) {
  .content-youtube,
  .content-play {
      margin-top: 4rem;
  }

  .content-album {
      margin: 2rem 0 3rem;
  }

  .content-text {
      margin-top: 12rem;
  }

  .content-albumtexts {
      font-size: 1.125rem;
  }
}

.content-text a {
  color: #ffebbe;
  text-decoration: none;
  box-shadow: 0 2px 0 -1px #ffebbe;
  transition: all 0.2s cubic-bezier(0,0,0.25,1);
}

.content-text a:hover  {
  color: #ffebbe;
  box-shadow: none;
}

.footer {
  margin-top: 5rem;
}

.footer-social-icons {
  margin-top: 0rem;
  z-index: 20;
}

.footer-social-icons ul {
  list-style: none;
  padding: 0;
  margin: 0;
  text-align: center;
  display: flex;
}

.footer-social-icons ul li {
  padding: 0;
  margin: 0 .5rem;
}

.footer-social-icons ul li a {
  color: #ffebbe;
  text-decoration: none;
  font-size: 4rem;
  transition: all 0.2s cubic-bezier(0,0,0.25,1);
}

.footer-social-icons ul li a:hover {
  color: #ffebbe;
}

.footer-social-icons ul li.facebook a,
.footer-social-icons ul li.twitter a,
.footer-social-icons ul li.youtube a {
  font-family: "Socialico";
}

.footer-social-icons ul li.instagram a,
.footer-social-icons ul li.spotify a {
  font-family: "SocialicoPlus";
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,wBAAwB;EACxB,4CAAyC;EACzC;;wDAEoD;AACtD;;AAEA;EACE,4BAA4B;EAC5B,4CAA0C;EAC1C;;wDAEqD;AACvD;;;AAGA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,4CAA4C;EAC5C,oBAAoB;;EAEpB,yDAAuD;EACvD,qBAAqB;EACrB,4BAA4B;EAC5B,4BAA4B;EAC5B,kBAAkB;AACpB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;;AAGA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE;IACE,6BAA6B;EAC/B;AACF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mCAAmC;EACnC,WAAW;AACb;;AAEA;;EAEE,YAAY;EACZ,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,QAAQ;EACR,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,gCAAgC;AAClC;;AAEA;;;EAGE,mBAAmB;EACnB,WAAW;AACb;;AAEA;AACA,eAAe;AACf;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;AACA,WAAW;AACX,YAAY;AACZ;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;;AAElB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,8BAA8B;AAChC;;;AAGA;EACE;;MAEI,gBAAgB;EACpB;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;MACI,gBAAgB;EACpB;AACF;;AAEA;EACE;;MAEI,gBAAgB;EACpB;;EAEA;MACI,mBAAmB;EACvB;;EAEA;MACI,iBAAiB;EACrB;;EAEA;MACI,mBAAmB;EACvB;AACF;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gCAAgC;EAChC,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,6CAA6C;AAC/C;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;;EAEE,4BAA4B;AAC9B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Schibsted+Grotesk:ital,wght@0,400;0,700;1,400;1,700&display=swap');\n\n@font-face {\n  font-family: \"Socialico\";\n  src: url('./fonts/Socialico-Regular.eot');\n  src: url('./fonts/Socialico-Regular.eot?#iefix') format('embedded-opentype'),\n  url('./fonts/Socialico-Regular.woff2') format('woff2'),\n  url('./fonts/Socialico-Regular.woff') format('woff');\n}\n\n@font-face {\n  font-family: \"SocialicoPlus\";\n  src: url('./fonts/SocialicoPlus-Plus.eot');\n  src: url('./fonts/SocialicoPlus-Plus.eot?#iefix') format('embedded-opentype'),\n  url('./fonts/SocialicoPlus-Plus.woff2') format('woff2'),\n  url('./fonts/SocialicoPlus-Plus.woff') format('woff');\n}\n\n\nbody {\n  background: hsl(240, 20%, 10%);\n  color: hsl(42, 100%, 87%);\n  margin: 0;\n  padding: 0;\n  font-family: 'Schibsted Grotesk', sans-serif;\n  padding: 1rem 0 4rem;\n\n  background-image: url('/src/img/bk-upptokur-cover.jpg');\n  background-size: 100%;\n  background-repeat: no-repeat;\n  background-position: 0 150px;\n  position: relative;\n}\n\n@media (min-width: 768px) {\n  body {\n    background-position: 0 0px;\n  }\n}\n\n@media (min-width: 992px) {\n  body {\n    background-position: 0 -70px;\n  }\n}\n\n\n@media (min-width: 1200px) {\n  body {\n    background-position: 0 -130px;\n  }\n}\n\n@media (min-width: 1400px) {\n  body {\n    background-position: 0 -200px;\n  }\n}\n\nbody:before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: hsla(240, 20%, 10%, .5);\n  z-index: -1;\n}\n\nhr,\n.seperator {\n  border: none;\n  border-top: 15px solid #ffebbe;\n}\n\n.seperator {\n  margin: 3rem 0;\n}\n\nh1, h2, h3, h4 {\n  line-height: 1.2;\n}\n\n.logo {\n  width: 75%;\n  max-width: 500px;\n  margin-top: 4rem;\n  z-index: 20;\n}\n\n.header, .main, .footer {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding-bottom: 0;\n}\n\n.header {\n  //padding-bottom: 10rem;\n}\n\n.header nav {\n  padding: 2rem 0;\n  font-size: 1.25rem;\n}\n\n.desktop-menu {\n  padding: 0;\n  margin: 0;\n  list-style: none;\n  display: none;\n  grid-gap: 20px;\n}\n\n.header nav li a {\n  color: #ffebbe;\n  text-decoration: none;\n}\n\n.header nav li a.active {\n  font-weight: 700;\n}\n\n.mobile-menu {\n  display: none;\n  text-align: center;\n  padding-top: 300px;\n  position: absolute;\n  inset: 0;\n  color: hsl(42, 100%, 87%);\n  background: hsla(240, 20%, 10%,.9);\n}\n\n.mobile-menu.open {\n  display: block;\n}\n\n.mobile-menu ul {\n  list-style: none;\n  padding: 0;\n}\n\n.mobile-menu li {\n  margin-bottom: 10px;\n}\n\n.desktop-menu {\n  display: none;\n  list-style: none;\n  padding: 0;\n}\n\n.desktop-menu li {\n  margin-right: 20px;\n}\n\n.mobile-menu-toggle,\n.close-menu-btn {\n  background: none;\n  border: none;\n  font-size: 1rem;\n  cursor: pointer;\n  padding: 10px;\n  background: hsl(42, 100%, 87%);\n  aspect-ratio: 1/1;\n  width: 2.5rem;\n  height: 2.5rem;\n  font-weight: 700;\n  line-height: 1.125;\n  border-radius: 50%;\n}\n\n@media (min-width: 768px) {\n  .desktop-menu {\n    display: flex;\n  }\n\n  .mobile-menu-toggle {\n    display: none;\n  }\n}\n\n.main-content {\n  width: 600px;\n  max-width: 75%;\n  text-shadow: 2px 2px 5px #14141e;\n}\n\n.content-album,\n.content-youtube,\n.content-play {\n  margin: 2rem 0 2rem;\n  z-index: 10;\n}\n\n.content-youtube {\npadding: 0 1rem;\n}\n\n.content-album iframe {\n  width: 100%;\n  aspect-ratio: 5 / 6;\n}\n\n.content-youtube iframe {\n  max-width: 100vw;\n  max-height: 56.25vw;\n}\n\n.content-play svg {\nwidth: 90px;\nheight: 90px;\n}\n\n.content-text {\n  z-index: 20;\n  font-size: 1.25rem;\n  line-height: 1.5;\n}\n\n.content-text.home {\n  font-size: 1.5rem;\n  text-align: center;\n  margin-top: 6rem;\n}\n\n@media (min-width: 768px) {\n  .content-text.home {\n    margin-top: 12rem;\n  }\n}\n\n.content-album {\n  font-size: 1rem;\n  line-height: 1.4;\n  \n}\n\n.track-title {\n  padding-top: 1rem;\n  margin-top: 5rem;\n  border-top: 15px solid #ffebbe;\n}\n\n\n@media (min-width: 900px) {\n  .content-youtube,\n  .content-play {\n      margin-top: 3rem;\n  }\n\n  .content-play svg {\n    width: 120px;\n    height: 120px;\n  }\n\n  .content-text {\n      margin-top: 6rem;\n  }\n}\n\n@media (min-width: 1200px) {\n  .content-youtube,\n  .content-play {\n      margin-top: 4rem;\n  }\n\n  .content-album {\n      margin: 2rem 0 3rem;\n  }\n\n  .content-text {\n      margin-top: 12rem;\n  }\n\n  .content-albumtexts {\n      font-size: 1.125rem;\n  }\n}\n\n.content-text a {\n  color: #ffebbe;\n  text-decoration: none;\n  box-shadow: 0 2px 0 -1px #ffebbe;\n  transition: all 0.2s cubic-bezier(0,0,0.25,1);\n}\n\n.content-text a:hover  {\n  color: #ffebbe;\n  box-shadow: none;\n}\n\n.footer {\n  margin-top: 5rem;\n}\n\n.footer-social-icons {\n  margin-top: 0rem;\n  z-index: 20;\n}\n\n.footer-social-icons ul {\n  list-style: none;\n  padding: 0;\n  margin: 0;\n  text-align: center;\n  display: flex;\n}\n\n.footer-social-icons ul li {\n  padding: 0;\n  margin: 0 .5rem;\n}\n\n.footer-social-icons ul li a {\n  color: #ffebbe;\n  text-decoration: none;\n  font-size: 4rem;\n  transition: all 0.2s cubic-bezier(0,0,0.25,1);\n}\n\n.footer-social-icons ul li a:hover {\n  color: #ffebbe;\n}\n\n.footer-social-icons ul li.facebook a,\n.footer-social-icons ul li.twitter a,\n.footer-social-icons ul li.youtube a {\n  font-family: \"Socialico\";\n}\n\n.footer-social-icons ul li.instagram a,\n.footer-social-icons ul li.spotify a {\n  font-family: \"SocialicoPlus\";\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
